export enum CountryCodes {
    Dummy = '#!',
    Australia = 'au',
    Austria = 'at',
    Belgium = 'be',
    Canada = 'ca',
    Finland = 'fi',
    France = 'fr',
    Germany = 'de',
    GreatBritain = 'gb',
    Greece = 'gr',
    Italy = 'it',
    Mexico = 'mx',
    Netherlands = 'nl',
    Poland = 'pl',
    SouthAfrica = 'za',
    Spain = 'es',
    Switzerland = 'ch',
    Turkey = 'tr',
    USA = 'us',
}
